import { request } from "../api";

// Anlagen
export const afaTable = () => request.get("/assets/afa-table");
export const listAssets = params => request.get("/assets", params);
export const getAsset = id => request.get(`/assets/${id}`);
export const previewSchedule = body => request.post("/assets/preview", body);
export const createAsset = body => request.post("/assets", body);
export const updateAsset = (id, body) => request.put(`/assets/${id}`, body);
export const deleteAsset = id => request.del(`/assets/${id}`);
export const disposeAsset = (id, body) => request.post(`/assets/${id}/dispose`, body);
export const runDepreciation = period => request.post("/assets/run-depreciation", { period });
export const anlagenspiegel = year => request.get("/assets/anlagenspiegel", { year });

// Kassenbuch
export const listCash = params => request.get("/cashbook", params);
export const cashBalance = () => request.get("/cashbook/balance");
export const addCashEntry = body => request.post("/cashbook/entries", body);
export const cashReport = params => request.get("/cashbook/report", params);
export const closeCashDay = (date, countedAmount) =>
  request.post(`/cashbook/days/${date}/close`, { countedAmount });
export const importDailyTotals = body => request.post("/cashbook/import-daily-totals", body);
export const listCategories = () => request.get("/ledger/accounts", { active: "true" });
export const listProjects = () => request.get("/reports/nachkalkulation/projects");

// Reisekosten
export const travelRates = () => request.get("/assets/travel/rates");
export const previewTrip = body => request.post("/assets/travel/trip?preview=1", body);
export const bookTrip = body => request.post("/assets/travel/trip", body);
export const previewEntertainment = body =>
  request.post("/assets/travel/entertainment?preview=1", body);
export const bookEntertainment = body => request.post("/assets/travel/entertainment", body);
